<script setup>
import { useForm } from "@inertiajs/inertia-vue3";
import Review from './Review'
import { ref } from "vue";

const props = defineProps({
  rentableProducts: Object,
  order_id: String,
})

const form = useForm({
  reviews: {},
})

const step = ref(0)

function submitForm() {

  if(step.value === props.rentableProducts.length -1) {
    form.transform((data) => ({
      ...data,
      order_id: props.order_id
    })).post(route('reviews.store'));
  }

  if(step.value < props.rentableProducts.length -1 ) {
    step.value = step.value + 1;
  }

}

</script>

<script>
  export default {
    layout: null,
  }
</script>

<template>
  <div>
    <Review v-model="form.reviews[step]" :rentableProduct="rentableProducts[step]" @submit="submitForm()" :key="step" />
  </div>
</template>



